import { Component } from '@angular/core';
import { GraphicService } from '../shared/graphic.service';
import { LoadedModules } from '../shared/esri-load-control.service';
import { NgIf, NgFor, NgStyle, DatePipe } from '@angular/common';

@Component({
    selector: 'popup-dist-percorrida',
    templateUrl: './popup-dist-percorrida.component.html',
    styleUrls: ['./popup-dist-percorrida.component.css'],
    standalone: true,
    imports: [NgIf, NgFor, NgStyle, DatePipe]
})
export class PopupDistPercorridaComponent {

  constructor(public graphicService: GraphicService){

  }


  zoomCaminhada(item){
    const mediaLat = item.coordenadas.reduce((sum, c) => sum + c.latitude, 0) / item.coordenadas.length;
    const mediaLong = item.coordenadas.reduce((sum, c) => sum + c.longitude, 0) / item.coordenadas.length;    

    const longitudes = item.coordenadas.map(c => c.longitude);
    const longitudeRange = Math.max(...longitudes) - Math.min(...longitudes);
    const deslocamento = longitudeRange * -3; 
 
    const novaLongitude = mediaLong + deslocamento;
    
    this.graphicService.view.goTo({
      center: [novaLongitude, mediaLat],
      zoom: 20
    });
  }
}
